<template>
  <div class="indexDIV">
    <div class="indexdiv">
      <div class="msg">
        <div class="msgChild">
          <div class="newTitlePage">
            <div class="imgBox">
              <p class="title">体 检 服 务 须 知</p>
            </div>
            <div class="imgBox">
              <p class="subTitle">点击查看并下载<a style="color: #FF000F;" @click="toPdf">《员工体检手册》</a>，了解详细操作流程</p>
            </div>
            <!-- <div class="title-msg">
              <p class="msg">
                <img src="../assets/boe提示.png" alt="" />
              </p>
            </div> -->
          </div>
          <div style="border-radius: 20px 20px 70px 70px">
            <div class="subscribeMsg">
              <!-- <img
                src="../assets/stars1.png"
                alt=""
                class="stars1"
                style="position: absolute; top: -125px; left: 64px"
              /> -->

              <div style="width: 900px; margin: 0 auto; position: relative">
                <!-- <img src="../assets/stars2.png" alt="" class="stars2" /> -->
                <!-- <p
                  style="
                    width: 40px;
                    height: 5px;
                    background: #FF000F;
                    margin-top: 40px;
                  "
                ></p> -->
                <p
                  style="
                    font-size: 22px;
                    line-height: 22px;
                    font-weight: 800;
                    color: #333;
                    margin-top: 40px;
                  "
                >
                  温馨提示：
                </p>
                <p
                  style="
                    font-size: 18px;
                    line-height: 20px;
                    font-weight: 800;
                    color: #FF000F;
                    margin-top: 30px;
                  "
                >
                  体检采用预约制，未预约直接前往可能无法正常安排体检。
                </p>
                <p
                style="
                  font-size: 18px;
                  line-height: 30px;
                  font-weight: 800;
                  color: #FF000F;
                  margin-top: 30px;
                "
              >
              如您预约爱康体检机构，请您留意由爱康发送的疫情调查问卷短信，请您仔细阅读后填写（必填，否则会影响您的当天体检权益），如填写完毕审核未通过，体检预约将被自动取消并冻结24小时后才可重新预约体检。
              </p>
                <div class="font" style="margin-top: 30px">
                  <div class="left">体检前</div>
                  <div class="right">
                    <p :key="index" v-for="(item, index) in arr1">
                      {{ item }}
                    </p>
                  </div>
                </div>
                <div class="font">
                  <div class="left">体检中</div>
                  <div class="right">
                    <p :key="index + '1'" v-for="(item, index) in arr2_1">
                      {{ item }}
                    </p>
                    <p :key="index + '2'" v-for="(item, index) in arr2_2">
                      <span
                        style="
                          display: inline-block;
                          width: 10px;
                          height: 10px;
                          background: #FF000F;
                          border-radius: 50%;
                          margin-right: 10px;
                          margin-left: 9px;
                        "
                      ></span>
                      {{ item }}
                    </p>
                    <p :key="index + '3'" v-for="(item, index) in arr2_3">
                      {{ item }}
                    </p>
                  </div>
                </div>
                <div class="font">
                  <div class="left">体检后</div>
                  <div class="right">
                    <p :key="index + '1'" v-for="(item, index) in arr3_1">
                      {{ item }}
                    </p>
                    <p
                      :key="index + '2'"
                      v-for="(item, index) in arr3_2"
                      style="color: #FF000F"
                    >
                      <span
                        style="
                          display: inline-block;
                          width: 10px;
                          height: 10px;
                          background: #FF000F;
                          border-radius: 50%;
                          margin-left: 9px;
                          margin-right: 10px;
                        "
                      ></span
                      >{{ item }}
                    </p>
                    <p :key="index + '3'" v-for="(item, index) in arr3_3">
                      {{ item }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="msg_footer">
                <p>如有问题，请联系客服电话：4000685099 转1 转6688</p>
                <div class="btn" @click="appoPhysicalTJ">去预约</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: "indexDIV",
        data() {
            return {
                enIsZh: 0,
                arr1: [
                    "1. 体检前一天请清淡饮食，勿饮酒、勿劳累，避免剧烈运动和情绪激动，保证充足睡眠",
                    "2. 女性同学请避开经期，请在经期结束3天后体检",
                    "3. 为保障您和其他同学的健康，患有上呼吸道传染性疾病的同学请痊愈后择期参检"
                ],
                arr2_1: [
                    "1. 体检当日清晨禁止喝水进食，长期服药者如必须服用药物请一口水送服，其他药物体检后服用。",
                    "2. 体检当日请携带个人预约证件于9:30前到达体检机构。",
                    "3. 备孕及孕期的同学请务必告知医护人员，将不再安排放射检查。",
                    "4. 体检当日宜着装轻便，请勿穿着连体类衣物，不要佩戴金属饰物，勿佩戴隐形眼镜。",
                    "5. 避免携带贵重物品或饰品，随身物品妥善保管。",
                    "6. 部分项目注意事项："
                ],
                arr2_2: [
                    "一般需空腹检查的项目是抽血、腹部B超、呼气实验等，具体可咨询导检人员是否可进行就餐。",
                    "内科检查前需要先进行一般检查检测血压。",
                    "放射线检查须除去身上佩戴的金银、玉器等饰物，以免影响检查结果。",
                    "女性做盆腔B超(腹式)检查前需饮水400-500毫升，使膀胱充盈，以确保检查结果准确 。"
                ],
                arr2_3: [],
                arr3_1: [
                    "1. 全部检查项目完毕后，请检查是否有漏项，确认无误后将导检单交至导检台。",
                    "2. 领取体检报告"
                ],
                arr3_2: [
                    "部分民营体检机构默认为电子版（检后7-10个工作日出具），爱康、美年、瑞慈可在本平台授权后查看；如未授权或无法本平台授权，请咨询体检机构或关注机构发送的相关通知；如需纸质或快递请咨询体检中心，相关费用需自理。 ",
                    "提醒：若您选择美年体检机构，在本平台授权查看体检报告，体检后仍需在门店填写授权书，同时授权才可在本平台在线查看体检报告。",
                    "公立医院默认为纸质版（检后7-15个工作日出具），不支持在本平台授权查看，获取的具体方式请在体检后至医院前台咨询，相关快递费用需自理。",
                    "家属体检报告，不支持在本平台授权查看，获取的具体方式请在体检后至医院前台咨询，相关快递费用需自理。"
                ],
                arr3_3: [
                    "3. 请妥善保存体检结果，以便与下次体检进行对照，也可作为就医的资料。"
                ]
            };
        },
        created() {

        },
        methods: {
            toPdf() {
                let _this = this;
                if (_this.$parent.batch == 'ABB21_V') {
                    window.open("../../../static/pdf/2021 ABB高管年度健康体检手册0708.pdf");
                } else {
                    window.open("../../../static/pdf/2021 ABB员工年度健康体检手册0708.pdf");
                }
            },
            appoPhysicalTJ() {
                console.log(this.$parent)
                this.$parent.appoPhysicalTJ()
            }
        },
        computed: {}
    };
</script>

<style scoped>
    .msgText {
        font-size: 24px;
        font-weight: bold;
        width: 720px;
        color: #ff000f;
    }
    
    .stars2 {
        position: absolute;
        right: 0;
    }
    
    .newTitlePage .title-msg {
        width: 1120px;
        height: 150px;
        background: #fff;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -560px;
        z-index: 100;
        border-radius: 40px 40px 0px 0px;
    }
    
    .title-msg .stars1 {
        position: absolute;
        left: 30px;
        bottom: -50px;
    }
    
    .newTitlePage .title-msg .msg {
        position: absolute;
        left: 50%;
        margin-left: -315px;
        top: 30px;
        width: 560px;
        /* height: 90px; */
        /* background: red; */
    }
    
    .title-msg .msg img {
        width: 100%;
        height: 100%;
    }
    
    .indexDIV {
        width: 100%;
        background-image: url("../../assets/backgroundImg.png");
        background-repeat: no-repeat;
        background-size: 126%;
        background-position: -175px 0;
    }
    
    .font {
        display: flex;
        margin-top: 20px;
    }
    
    .font .left {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 600;
        color: #ff000f;
        line-height: 30px;
        border-radius: 20px;
        background: #fef8f8;
        /* box-shadow:0px 0px 20px 0px rgba(87,140,255,0.18); */
        /* border-radius: 4px 0px 0px 4px; */
    }
    
    .font .right {
        width: 100%;
        flex: 1;
        font-size: 16px;
        color: #666666;
        line-height: 30px;
        background: #fef8f8;
        /* box-shadow:0px 0px 20px 0px rgba(87,140,255,0.18); */
        border-radius: 20px;
        margin-left: 10px;
        padding: 20px;
        text-align: justify;
    }
    
    .Wrisubscribe {
        width: 400px;
        height: 50px;
        background: #ff000f;
        /*box-shadow:0px 0px 50px 0px rgba(41,45,53,0.15);*/
        /*border-radius:4px;*/
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin: 0 auto;
        margin-top: 113px;
        margin-bottom: 50px;
    }
    
    .indexdiv {}
    
    .indexdiv .img {
        width: 100%;
        /*height: 260px;*/
        min-width: 1180px;
    }
    
    .indexdiv .img img {
        width: 100%;
    }
    
    .indexdiv .msg {
        width: 100%;
        margin: 0 auto;
        /* background:linear-gradient(90deg,rgba(86,191,255,0.2) 0%,rgba(86,139,255,0.2) 100%); */
    }
    
    .indexdiv .msg .msgChild {
        width: 1180px;
        margin: 0 auto;
        /* padding-top: 40px; */
    }
    
    .indexdiv .msg h3 {
        width: 1180px;
        font-size: 30px;
        margin: 0 auto;
        font-weight: 600;
        color: #333;
        line-height: 30px;
        text-align: center;
    }
    
    .indexdiv .msg .subscribe {
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        line-height: 20px;
        width: 400px;
        height: 50px;
        background: #006199;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        margin: 0 auto;
        margin-top: 50px;
        cursor: pointer;
    }
    
    .subscribeMsg {
        width: 1180px;
        padding-bottom: 50px;
        /* box-shadow: 0px 0px 30px 0px rgba(0, 122, 255, 0.1); */
        padding-top: 10px;
        border-radius: 20px 20px 70px 70px;
        position: relative;
        z-index: 100;
    }
    
    .subscribeMsg .img1 {
        width: 800px;
        margin: 0 auto;
        margin-top: 20px;
    }
    
    .subscribeMsg .div1 {
        width: 940px;
        margin: 0 auto;
        margin-top: 55px;
        display: flex;
        justify-content: space-between;
    }
    
    .subscribeMsg .div1 .msg {
        width: 280px;
        background: #fff;
        box-shadow: inset 0px 0px 20px 0px #e5f7f5;
        border-radius: 30px;
        position: relative;
        padding-bottom: 27px;
    }
    
    .subscribeMsg .div1 .msg .icon {
        width: 70px;
        height: 70px;
        background: #fff;
        box-shadow: 0px 7px 7px -2px #e5f7f5;
        border-radius: 50%;
        display: flex;
        align-items: center;
        padding-left: 8px;
        position: absolute;
        left: 50%;
        margin-left: -35px;
        top: -35px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .subscribeMsg .div1 .msg:nth-child(1) .icon img {
        margin-left: -15px;
    }
    
    .subscribeMsg .div1 .msg:nth-child(2) .icon img {
        margin-left: -17px;
    }
    
    .subscribeMsg .div1 .msg:nth-child(3) .icon img {
        margin-left: -10px;
    }
    
    .subscribeMsg .div1 .msg .p1 {
        font-size: 18px;
        font-weight: bold;
        color: #ff000f;
        line-height: 30px;
        text-align: center;
        margin-top: 60px;
        padding-bottom: 8px;
    }
    
    .subscribeMsg .div1 .msg .p2,
    .subscribeMsg .div1 .msg .p3,
    .subscribeMsg .div1 .msg .p4 {
        font-size: 16px;
        font-weight: 500;
        color: #4a4a4a;
        line-height: 30px;
        text-align: center;
        padding: 0 15px;
    }
    
    h4 {
        font-size: 40px;
        font-weight: 600;
        color: #333;
        line-height: 40px;
        margin: 30px 0;
    }
    
    .breadNav {
        width: 100%;
        height: 80px;
        border-bottom: 2px solid #eaeaea;
        display: flex;
        align-items: center;
    }
    
    .breadNav .nav {
        width: 1180px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    
    .breadNav .nav p:nth-child(1) {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 20px;
    }
    
    .breadNav .nav p:nth-child(2) {
        font-size: 24px;
        font-weight: 600;
        color: #ff000f;
        line-height: 24px;
    }
</style>
<style lang="scss" scoped>
    .newTitlePage {
        .title {
            font-size: 42px;
            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
            font-weight: bold;
            color: #191919;
            line-height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            &::after {
                content: "";
                width: 100px;
                height: 10px;
                display: inline-block;
                background: linear-gradient( 270deg, rgba(255, 255, 255, 0) 0%, #ff000f 100%);
                border-radius: 100px;
                margin-left: 30px;
            }
            &::before {
                content: "";
                width: 100px;
                height: 10px;
                display: inline-block;
                background: linear-gradient( 90deg, rgba(255, 255, 255, 0) 0%, #ff000f 100%);
                border-radius: 100px;
                margin-right: 30px;
            }
        }
        .subTitle {
            margin-top: 20px;
            text-align: center;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #191919;
            line-height: 24px;
            a {
                cursor: pointer;
                text-decoration: none;
            }
        }
    }
    
    .msg_footer {
        width: 900px;
        margin: 30px auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        p {
            color: #ff000f;
        }
        .btn {
            width: 180px;
            height: 46px;
            background: #ff000f;
            border-radius: 23px;
            color: #ffffff;
            text-align: center;
            line-height: 46px;
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/manual.vue